export const getNodes = ({
  selector,
  context = document,
}: {
  selector: string;
  context?: HTMLElement | Document;
}): HTMLElement[] => {
  return [...context.querySelectorAll<HTMLElement>(selector)];
};
